import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';

export interface PurchaseConfirmation {
  statusCode: number,
  success: boolean,
  refNumber?: string,
  email?: string,
  status?: string,
  type?: string,
  productName?: string,
  company?: string,
  street?: string,
  zip?: string,
  city?: string,
  country?: string,
}

interface CheckoutFromServer {
  error?: string,
  data?: {
    getPurchaseByStripeSessionId: PurchaseConfirmation
  }
}

@Injectable({
  providedIn: 'root'
})
export class PurchaseService {

  constructor(
    private readonly backendService: BackendService
  ) {
  }

  async getPurchaseByStripeSessionId(stripeSessionId: string): Promise<PurchaseConfirmation> {
    const response = await this.backendService.executeGraphQL(
      `query GetPurchaseByStripeSessionId($stripeSessionId: String!) {
        getPurchaseByStripeSessionId(sessionId: $stripeSessionId) {
          statusCode
          success
          refNumber
          email
          status
          type
          productName
          company
          street
          zip
          city
          country
      `, {stripeSessionId}
    ) as CheckoutFromServer;

    if (response.error != null || response.data == null || response.data.getPurchaseByStripeSessionId == null) {
      console.error('Failed to get purchase by stripe session id:', stripeSessionId, response.error);
      return {
        statusCode: 500,
        success: false
      };
    }

    return response.data.getPurchaseByStripeSessionId;
  }
}
